import { render } from "./EducationModal.vue?vue&type=template&id=4362212d&scoped=true"
import script from "./EducationModal.vue?vue&type=script&lang=js"
export * from "./EducationModal.vue?vue&type=script&lang=js"

import "./EducationModal.vue?vue&type=style&index=0&id=4362212d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4362212d"]])

export default __exports__